import React from 'react';

interface AttachmentSectionProps {
  attachments?: any[];
  isEditable: boolean;
  canAddAttachments?: boolean;
  showAttachmentList?: boolean;
  isPreview: boolean;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: (index: number) => void;
}

export const AttachmentSection: React.FC<AttachmentSectionProps> = ({
  attachments = [],
  isEditable,
  canAddAttachments = isEditable,
  showAttachmentList = true,
  isPreview,
  onFileChange,
  onRemoveFile,
}) => {
  const fileInputId = React.useId();
  const pendingAttachments = attachments
    .map((file, index) => ({ file, index }))
    .filter(({ file }) => file instanceof File);

  return (
    <div className="pt-6 pb-2 border-t border-slate-200 mt-6 print:hidden">
      <label className="text-slate-800 font-medium text-sm block mb-2">
        📎 ပူးတွဲဖိုင်များ (Attach Files)
      </label>

      {canAddAttachments && !isPreview && (
        <div className="flex items-center gap-2 mb-3">
          <input
            type="file"
            multiple
            id={fileInputId}
            onChange={(event) => {
              onFileChange(event);
              event.currentTarget.value = '';
            }}
            className="hidden"
          />
          <label
            htmlFor={fileInputId}
            className="cursor-pointer bg-slate-100 hover:bg-slate-200 border border-slate-300 text-slate-700 text-xs font-semibold px-4 py-2 rounded-lg transition flex items-center gap-1.5"
          >
            📁 ဖိုင်ရွေးချယ်ရန် (Choose Files)
          </label>
        </div>
      )}

      {showAttachmentList && pendingAttachments.length > 0 ? (
        <ul className="space-y-1.5">
          {pendingAttachments.map(({ file, index }) => (
            <li
              key={`${file.name}-${file.lastModified}-${index}`}
              className="flex items-center justify-between text-xs bg-slate-50 border border-slate-200 rounded p-2 text-slate-700"
            >
              <span className="truncate max-w-xs">📎 {file.name}</span>
              {canAddAttachments && !isPreview && (
                <button
                  type="button"
                  onClick={() => onRemoveFile(index)}
                  className="text-rose-500 hover:text-rose-700 font-bold px-1"
                >
                  ✕
                </button>
              )}
            </li>
          ))}
        </ul>
      ) : showAttachmentList ? (
        <span className="text-slate-400 text-xs italic">(ပူးတွဲဖိုင် မရှိပါ)</span>
      ) : null}
    </div>
  );
};